export const listaSolicitacoesTabs = [
    {
        id: 1,
        title: 'Solicitações de carteirinha',
        menuId: 'Carteirinha',
        active: false,
    },
    // {
    //     id: 2,
    //     title: 'Consulta de solicitacão',
    //     menuId: 'Lista de solicitações',
    //     active: true
    // }
];

export const solicitacaoSegundaViaTabs = [
    {
        id: 1,
        title: 'Solicitações de carteirinha',
        menuId: 'Carteirinha',
        active: true,
    },
    // {
    //     id: 2,
    //     title: 'Consulta de solicitacão',
    //     menuId: 'Lista de solicitações',
    //     active: false
    // }
];

export const carteirinhaDigitalTabs = [
    {
        id: 1,
        title: 'Carteirinha digital',
        menuId: 'Carteirinha',
        active: true,
    },
    // {
    //     id: 2,
    //     title: 'Consulta de solicitacão',
    //     menuId: 'Lista de solicitações',
    //     active: false
    // }
];
